<template lang="pug">
b-container(fluid="lg")
  .tabla.sombra
    ShopifyIntegrationConfig(v-if="checkPermissions([permissions.STORE_SHOPIFY_INTEGRATION])")
    JumpsellerIntegrationConfig.mt-4(v-if="user.role === 'store'")
    MercadolibreIntegrationConfig(v-if="user.role === 'store'")
    ApiConfig.mt-4(v-if="checkPermissions([permissions.STORE_API_ACCESS])")
    WebhookConfig.mt-4(v-if="checkPermissions([permissions.STORE_API_ACCESS])")
</template>

<script>
import ApiConfig from '../components/integrations/ApiConfig'
import ShopifyIntegrationConfig from '../components/integrations/ShopifyIntegrationConfig'
import JumpsellerIntegrationConfig from '../components/integrations/JumpsellerIntegrationConfig'
import MercadolibreIntegrationConfig from '../components/integrations/MercadolibreIntegrationConfig'
import WebhookConfig from '../components/integrations/WebhookConfig'
import { permissions } from '../utils/authUtils'
import { mapGetters } from 'vuex'

export default {
  components: {
    ApiConfig,
    ShopifyIntegrationConfig,
    JumpsellerIntegrationConfig,
    MercadolibreIntegrationConfig,
    WebhookConfig
  },
  data () {
    return {
      permissions
    }
  },
  computed: {
    ...mapGetters(['user', 'checkPermissions'])
  }
}
</script>
